import { render, staticRenderFns } from "./RobberyComplaintFiledIntroQuestion.vue?vue&type=template&id=e9f316e6"
import script from "./RobberyComplaintFiledIntroQuestion.vue?vue&type=script&lang=ts"
export * from "./RobberyComplaintFiledIntroQuestion.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports